module.exports = __webpack_public_path__ + "static/media/1.7f29e752.svg";